import React, { useEffect, useRef } from 'react';
import { Button, CloseButton, Modal } from 'react-bootstrap';
import OptionComments from '../../../app/brand/campaign/options/components/OptionComments';
import { IBundle } from '../../../model/options/IBundle';
import { useDispatch } from 'react-redux';
import { offerInfluencer } from '../../../store/influencer/offerInfluencerSlice';
import { useTranslation } from 'react-i18next';
import { IMessageOpenedChat } from '../../../app/brand/campaign/messages/dto/IMessage';

interface ICommentModal {
    show: boolean;
    closeModal: (...args: any) => void;
    sendMessageHandler: (...args: any) => void;
    setNewMessage: (...args: any) => void;
    setIdOffer?: (...args: any) => void;
    newMessage: string;
    title?: string;
    textNoComments?: string;
    showCloseBtn?: boolean;
    hideFooter?: boolean;
    isSendDisabled: boolean;
    bundle: IBundle | undefined | { comments: IMessageOpenedChat[] };
    canMention?: boolean;
    hideOptionsCommentsTitle?: boolean;
}

export default function CommentModal({
    show,
    closeModal,
    sendMessageHandler,
    newMessage,
    setNewMessage,
    isSendDisabled,
    bundle,
    setIdOffer,
    canMention,
    title,
    showCloseBtn,
    hideOptionsCommentsTitle,
    hideFooter,
    textNoComments,
}: ICommentModal) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const lastMessageRef = useRef<HTMLElement>(null);

    useEffect(() => {
        if (bundle?.comments?.length && lastMessageRef?.current) {
            lastMessageRef?.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        }
    }, [bundle?.comments?.length, lastMessageRef?.current]);

    return (
        <Modal
            show={show}
            onHide={() => {
                dispatch(offerInfluencer.actions.setBundle({ comments: [] }));
                closeModal((prev: any) => ({ ...prev, show: false }));
                setIdOffer?.(0);
            }}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            {!!title && (
                <Modal.Header className="flex-wrap pb-0">
                    <div className="w-100 border-bottom d-flex pb-1 align-items-center justify-content-between">
                        <Modal.Title className="">{title}</Modal.Title>
                        {showCloseBtn && (
                            <CloseButton
                                className="float-none m-0 p-0"
                                onClick={() => {
                                    dispatch(offerInfluencer.actions.setBundle({ comments: [] }));
                                    closeModal((prev: any) => ({ ...prev, show: false }));
                                    setIdOffer?.(0);
                                }}
                            />
                        )}
                    </div>
                </Modal.Header>
            )}
            <Modal.Body className="p-0">
                <OptionComments
                    bundle={bundle as IBundle}
                    sendMessageHandler={sendMessageHandler}
                    lastMessageRef={lastMessageRef}
                    styleCard="shadow-none border-0"
                    newMessage={newMessage}
                    setNewMessage={setNewMessage}
                    isSendDisabled={isSendDisabled}
                    canMention={canMention}
                    textNoComments={textNoComments}
                    hideTitle={hideOptionsCommentsTitle}
                />
            </Modal.Body>
            {!hideFooter && (
                <Modal.Footer className="pt-0">
                    <Button
                        className="btn-outline-primary"
                        onClick={() => {
                            dispatch(offerInfluencer.actions.setBundle({ comments: [] }));
                            closeModal((prev: any) => ({ ...prev, show: false }));
                            setIdOffer?.(0);
                        }}
                    >
                        {t('general.button.cancel')}
                    </Button>
                </Modal.Footer>
            )}
        </Modal>
    );
}
